import React, { FC } from "react";

import { Menu } from "../../../../pages/teacher/ManageBoxesPage/types";

import styles from "./ListSelector.module.scss";

type Props = {
  menu: Menu;
  onChangeMenu: (menu: Menu) => void;
};

const ListSelector: FC<Props> = ({ menu, onChangeMenu }) => {
  return (
    <div className={styles.listSelector}>
      <label className={styles.radioLabel}>
        <input
          type="radio"
          name="menu"
          checked={menu === "box"}
          onChange={() => onChangeMenu("box")}
        />
        <span className={styles.dot} />
        <span className={styles.name}>BOX一覧</span>
      </label>
      <label className={styles.radioLabel}>
        <input
          type="radio"
          name="menu"
          checked={menu === "template"}
          onChange={() => onChangeMenu("template")}
        />
        <span className={styles.dot} />
        <span className={styles.name}>オリジナルテンプレート一覧</span>
      </label>
    </div>
  );
};

export default ListSelector;
